import { useAuth } from '../contexts/AuthContext';
import { getAccountUrl } from '../utils/platform';

/**
 * Shown in place of PricingModal/UpgradeModal content when the app
 * is running inside the webtoapp.design native wrapper.
 *
 * Apple compliance: no pricing, no amounts, no checkout buttons.
 * Just a message + link that opens native Safari (not in-app WebView).
 *
 * @param {Object} props
 * @param {Function} props.onClose - Close the modal
 * @param {string} [props.title] - Optional title override
 * @param {string} [props.subtitle] - Optional subtitle override
 */
export default function AppUpgradeNotice({ onClose, title, subtitle }) {
  const { user } = useAuth();
  const accountUrl = getAccountUrl(user?.email);

  return (
    <div
      onClick={onClose}
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(0,0,0,0.7)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 200,
        padding: 20,
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'var(--bg-card)',
          borderRadius: 'var(--radius-lg)',
          padding: 24,
          width: '100%',
          maxWidth: 420,
          textAlign: 'center',
        }}
      >
        {/* External link icon */}
        <div
          style={{
            width: 56,
            height: 56,
            borderRadius: '50%',
            background: 'var(--accent-subtle)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="var(--accent)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
            <polyline points="15 3 21 3 21 9" />
            <line x1="10" y1="14" x2="21" y2="3" />
          </svg>
        </div>

        <h2 style={{ fontSize: '1.125rem', fontWeight: 700, marginBottom: 8 }}>
          {title || 'Manage Plan & Other Account Settings'}
        </h2>
        <p
          style={{
            fontSize: '0.875rem',
            color: 'var(--text-muted)',
            lineHeight: 1.5,
            marginBottom: 24,
          }}
        >
          {subtitle ||
            'To manage your plan and account settings, please visit propermiles.com in your web browser.'}
        </p>

        {/* Opens native Safari/Chrome via target="_blank" in webtoapp.design */}
        <a
          href={accountUrl}
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: 'block',
            padding: '14px 20px',
            borderRadius: 'var(--radius-sm)',
            background: 'var(--accent)',
            color: '#fff',
            fontWeight: 700,
            fontSize: '0.9375rem',
            textDecoration: 'none',
            marginBottom: 12,
          }}
        >
          Continue in Browser
        </a>

        <button
          onClick={onClose}
          style={{
            padding: '10px 20px',
            borderRadius: 'var(--radius-sm)',
            border: 'none',
            background: 'transparent',
            color: 'var(--text-muted)',
            fontSize: '0.875rem',
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          Maybe Later
        </button>
      </div>
    </div>
  );
}
